// window.open returns null when the browser blocks the pop-up, and this app
// dereferences the result all over the place - .focus(), .close(), .document.
// Every one of those is a TypeError waiting to happen, and a TypeError thrown
// from render or a commit-phase lifecycle takes the whole React tree down with
// it (see components/ErrorBoundary.js). Route named-window access through here.
//
// Note what window.open('', name) actually does: it re-focuses the window with
// that name if one exists, and CREATES a blank one if it does not. So these
// helpers can open a window as a side effect of closing it - which is what the
// call sites already did, and is preserved deliberately rather than quietly
// changed. Only the null dereference is fixed.
//
// The try/catch is for cross-origin and detached-window edge cases, where
// touching the handle can throw even though it is not null.

export const openNamedWindow = (name, features) => {
    try {
        return window.open('', name, features === undefined ? '' : features) || null;
    } catch (e) {
        return null;
    }
};

// Returns true when the window was there to act on, false when it was blocked -
// so callers can tell the user rather than failing silently.
export const focusNamedWindow = (name, features) => {
    const target = openNamedWindow(name, features);
    if (!target) {
        return false;
    }
    try {
        target.focus();
        return true;
    } catch (e) {
        return false;
    }
};

export const closeNamedWindow = (name, features) => {
    const target = openNamedWindow(name, features);
    if (!target) {
        return false;
    }
    try {
        target.close();
        return true;
    } catch (e) {
        return false;
    }
};

export default { openNamedWindow, focusNamedWindow, closeNamedWindow };



// WEBPACK FOOTER //
// ./src/utils/popupWindows.js